/**
 * Estados de disponibilidade do médico exibidos no paywall do chat e na
 * tela de pagamento.
 *
 * Introduzido no refactor 9f2b7d9 (02/06/2026) que extraiu a lógica inline
 * de polling/render de `ConsultaChat.jsx` e `Pagamento.jsx`.
 */

export const DOCTOR_STATUS = Object.freeze({
  LOADING: 'loading', // estado inicial, antes do primeiro fetch
  ONLINE: 'online',   // backend retornou available === true
  RESTING: 'resting', // backend retornou available === false (modo assíncrono)
  UNKNOWN: 'unknown', // falha de rede / status HTTP != 2xx
});

export function statusFromAvailability(available) {
  if (available === true) return DOCTOR_STATUS.ONLINE;
  if (available === false) return DOCTOR_STATUS.RESTING;
  return DOCTOR_STATUS.UNKNOWN;
}
